// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qz-0";